'use strict'

const u = require('universalify').fromCallback
const jsonFile = require('jsonfile')

module.exports = {
  // jsonfile exports
  readJson: u(jsonFile.readFile),
  readJsonSync: jsonFile.readFileSync,
  writeJson: u(jsonFile.writeFile),
  writeJsonSync: jsonFile.writeFileSync
}



//////////////////
// WEBPACK FOOTER
// ./~/fs-extra/lib/json/jsonfile.js
// module id = 216
// module chunks = 0